import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import {  firstValueFrom, Subscription } from 'rxjs';
import { ProxyServiceFetchURLService } from '../../../../../../../shared/services/proxy-service-fetch-url.service';
import { PackService } from '../../../../../../contributor/components/profile/contributors/pack/services/pack.service';
import { ImageFormat } from '../../../gallery/icon-gallery/models/image-format';
import { IconGalleryService } from '../../../gallery/icon-gallery/services/iconGallery.service';
import { NgForm } from '@angular/forms';
import { AiService } from '../../services/ai.service';
import { ImageUpScalarRequestModel, ImageUpScalarResponseModel } from '../../models/image-enhancer';
import { BlobService } from '../../../../../../../shared/services/blob.service';
type Tabs = 'Original' | 'UpScaled-image';
@Component({
  selector: 'app-image-upscalar',
    standalone:false,

  templateUrl: './image-upscalar.component.html',
  styleUrl: './image-upscalar.component.css'
})
export class ImageUpscalarComponent implements OnInit {
  activeTab: Tabs = 'Original';
  fileError: string | null = null;
  isFileSelected!: boolean;
  allowedExtensions: string[] = ['jpg', 'png', 'jpeg'];
  imageUpScalarRequestModel: ImageUpScalarRequestModel = new ImageUpScalarRequestModel();
  imageUpScalarResponeModel: ImageUpScalarResponseModel = new ImageUpScalarResponseModel();
  isLoading: boolean = false;
  imageUrl: string | ArrayBuffer | null = null;
  isDownloading: boolean = false;
  @ViewChild('enhanceImageForm') enhanceImageForm!: NgForm;
  enhanceImageSubscription!: Subscription;


  constructor(
    private aiService: AiService,
    public proxyServiceFetchURLService: ProxyServiceFetchURLService,
    private packService: PackService,
    private iconGalleryService: IconGalleryService,
    private blobService:BlobService,
    private cdr: ChangeDetectorRef
  ) {}

  async ngOnInit() {
    this.preventBrowserDefaults();
  }


  onSelect(event: Event): void {
    this.fileError = null;
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const fileExtension = file.name.split('.').pop()?.toLowerCase();
      const fileSizeMB = file.size / (1024*1024);
      if(fileSizeMB > 10){
        this.clear();
        this.fileError = 'File size exceeds 10MB. Please select a smaller file.';
        return;
      }
      if (fileExtension && this.allowedExtensions.includes(fileExtension)) {
        this.handleFileSelection(file);
      } else {
        this.imageUpScalarRequestModel.file = null;
        this.enhanceImageForm.resetForm(this.imageUpScalarRequestModel);
        this.isFileSelected = true;
        this.fileError = `Invalid file type.Please select a valid file (${this.allowedExtensions.join(
          ','
        )}).`;
      }
    }
  }
  handleFileSelection(file: File): void {
    if (file) {
      this.imageUpScalarRequestModel.file = file;
      this.isFileSelected = true;
      const reader = new FileReader();
      reader.onload = (e) => (this.imageUrl = reader.result);
      reader.readAsDataURL(file);
      this.imageUpscalar();
    } else {
      this.imageUpScalarRequestModel.file = null;
      this.isFileSelected = true;
    }
  }

  get isValidFile(): boolean {
    if (!this.imageUpScalarRequestModel.file) {
      return false;
    }
    const fileName = this.imageUpScalarRequestModel.file.name.toLowerCase();
    return (
      fileName.endsWith(ImageFormat.Png.toString().toLowerCase()) ||
      fileName.endsWith(ImageFormat.Jpeg.toString().toLowerCase()) ||
      fileName.endsWith(ImageFormat.Jpeg.toString().toLowerCase())
    );
  }

  clearFile(fileInput: HTMLInputElement): void {
    fileInput.value = '';
    this.imageUpScalarRequestModel.file = null;
    this.isFileSelected = false;
    this.fileError = null;
    this.isLoading = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.fileError = null;
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const file = files[0];
      const fakeInputEvent = {
        target: { files: [file] },
      } as unknown as Event;
      this.onSelect(fakeInputEvent);
    }
  }

  allowDrop(event: DragEvent) {
    event.preventDefault();
  }

  preventBrowserDefaults() {
    ['dragover', 'drop'].forEach((eventName) => {
      window.addEventListener(
        eventName,
        (e) => {
          e.preventDefault();
        },
        false
      );
    });
  }

  clear(): void {
    this.imageUpScalarRequestModel.file = null;
    this.isFileSelected = false;
    this.fileError = null;
    this.imageUrl = null;
    this.isLoading = false;
    this.isDownloading = false;
    this.activeTab = 'Original';
    this.imageUpScalarResponeModel.base64_image = '';
    this.imageUpScalarResponeModel.content_type = '';
    this.enhanceImageForm.resetForm();
    if (this.enhanceImageSubscription) {
      this.enhanceImageSubscription.unsubscribe();
    }
    this.cdr.detectChanges();
  }

  async imageUpscalar() {
    this.isLoading = true;
    this.fileError = null;
    this.activeTab = 'UpScaled-image';
    this.enhanceImageSubscription = await this.aiService
      .imageUpscalar(this.imageUpScalarRequestModel)
      .subscribe({
        next: (data: ImageUpScalarResponseModel) => {
          this.imageUpScalarResponeModel = data;
          this.isLoading = false;
          setTimeout(() => {
            this.cdr.detectChanges();
          }, 500);
        },
        error: (err) => {
          this.isLoading = false;
          this.fileError = err?.error?.errors?.[0].message || err?.error?.errors?.[0].errors?.[0];
        },
      });
  }

  get getImageSource():string{
    return `data:${this.imageUpScalarResponeModel.content_type};base64,${this.imageUpScalarResponeModel.base64_image}` ;
  }

  async downloadImage() {
    this.iconGalleryService.downloadBase64(
      'img_Upscale',
      this.imageUpScalarResponeModel.base64_image,
      this.imageUpScalarResponeModel.content_type.replace('image/','')
    );
    setTimeout(() => {
      this.isDownloading = false;
      this.cdr.detectChanges();
    }, 500);
  }

  setTab(tab: Tabs): void {
    this.activeTab = tab;
  }

  activeClass(tab: Tabs) {
    return tab === this.activeTab ? ' active' : '';
  }
  ngOnDestroy(): void {
    if (this.enhanceImageSubscription) {
      this.enhanceImageSubscription.unsubscribe();
    }
  }
}
